import FileUpload from './fileUpload'
export default FileUpload



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/file-upload/index.jsx